import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

export const ColumnHints: FC = () => {
  const texts = useTexts();

  return (
    <ColumnHintsContainer>
      <div className="font-details">
        <StyledSup>1</StyledSup>
        {texts.widgets.assetAllocation.table.hints.percent.monthToDate}
      </div>
      <div className="font-details">
        <StyledSup>2</StyledSup>
        {texts.widgets.assetAllocation.table.hints.percent.yearToDate}
      </div>
    </ColumnHintsContainer>
  );
};

const ColumnHintsContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  gap: 16px;
`;

const StyledSup = styled.sup`
  font-weight: 700;
  margin-right: 4px;
`;
